"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALTERNATE_NAME_FIELDS = void 0;
var entities_1 = require("@common/entities");
exports.ALTERNATE_NAME_FIELDS = [
    __assign(__assign({}, entities_1.AlternateNameFields.firstName), { customType: entities_1.FieldType.Text, required: false, type: entities_1.FieldType.Text, enabled: true, sequence: 1 }),
    __assign(__assign({}, entities_1.AlternateNameFields.middleName), { customType: entities_1.FieldType.Text, required: false, type: entities_1.FieldType.Text, enabled: true, sequence: 2 }),
    __assign(__assign({}, entities_1.AlternateNameFields.lastName), { customType: entities_1.FieldType.Text, required: false, type: entities_1.FieldType.Text, enabled: true, sequence: 3 }),
];
